<div class="d-flex flex-column align-items-center dashed-box text h-100"
     [ngClass]="wrapperClasses">
    <!-- <div class="d-flex">
        @for (serviceApplication of serviceApplicationsForDisplay(); track $index; let i = $index) {
            @if (serviceApplication.value()) {
                <span [ngClass]="serviceApplication.icon"
                      class="round-icon big-icon service-application"></span>
            }
        }
    </div>

    <button kendoButton
            icon="plus"
            class="round-icon add small-icon bg-green-dark"
            (click)="toggleDialog()">
    </button>
    @if (hasNoServiceApplications()) {
    <div>Add service applications</div>
    } -->

    <div class="grid-container">
        @for (serviceApplication of state().serviceApplicationsForDisplay(); track serviceApplication.applicationTypeId) {
        <pmis3-vessel-visit-detail-movement-service-application-picker-button [isSelected]="serviceApplication.value()"
                                                                              (isSelectedChange)="onToggleService(serviceApplication.applicationTypeId, $event)"
                                                                              [label]="serviceApplication.label"
                                                                              [icon]="serviceApplication.icon">
        </pmis3-vessel-visit-detail-movement-service-application-picker-button>
        }
    </div>
</div>

<!-- @if (showDialog()) {
<kendo-dialog title="Select Service Requests"
              (close)="toggleDialog()"
              [minWidth]="250"
              [width]="450">
    <div class="grid-container">
        @for (serviceApplication of serviceApplicationsForDisplay(); track serviceApplication.applicationTypeId) {
        <pmis3-vessel-visit-detail-movement-service-application-picker-button [isSelected]="serviceApplication.value()"
                                                                              (isSelectedChange)="onToggleService(serviceApplication.applicationTypeId, $event)"
                                                                              [label]="serviceApplication.label"
                                                                              [icon]="serviceApplication.icon">
        </pmis3-vessel-visit-detail-movement-service-application-picker-button>
        }
    </div>
    <kendo-dialog-actions>
        <button kendoButton
                (click)="save()"
                themeColor="primary">
            Add Services
        </button>
    </kendo-dialog-actions>
</kendo-dialog>
} -->